import { createFileRoute } from "@tanstack/react-router";

import SelfServeSignupPage from "@/features/auth/pages/self-serve-signup";
import { AuthProvider } from "@/providers/auth.provider";

export const Route = createFileRoute("/(auth)/self-serve-signup")({
  component: () => (
    <AuthProvider>
      <main role="main" aria-label="Self-serve signup page" className="min-h-screen w-full">
        <SelfServeSignupPage />
      </main>
    </AuthProvider>
  ),
});
